import * as React from 'react';
import { ApolloProvider } from '@apollo/react-hooks';

import FareConditionsModal, { Props } from './FareConditionsModal';
import { useGraphQLClient } from '../../graphql-client';
import { Locale, Omit } from '../../types';
import { getLocale } from '../../utils';

export type OwnProps = Omit<Omit<Props, 'onLangChange'>, 'language'>;

const LOCALE_TO_LANG_MAP = new Map<Locale | string, string>([
	[Locale.English, 'en'],
	[Locale.Russian, 'ru'],
	[Locale.Kazakh, 'ru'],
	[Locale.Belarusian, 'ru']
]);
const Component: React.FunctionComponent<OwnProps> = props => {
	const client = useGraphQLClient();
	const engineLang = getLocale();

	const [currentLang, changeLangTo] = React.useState(() => {
		if (LOCALE_TO_LANG_MAP.has(engineLang)) {
			return LOCALE_TO_LANG_MAP.get(engineLang);
		} else {
			return Locale.English;
		}
	});

	const handleChange: React.Dispatch<Locale> = lang => {
		if (LOCALE_TO_LANG_MAP.has(lang)) {
			changeLangTo(lang);
		} else {
			changeLangTo(Locale.English);
		}
	};

	return (
		<ApolloProvider client={client}>
			<FareConditionsModal onLangChange={handleChange} language={currentLang} {...props} />
		</ApolloProvider>
	);
};

export default Component;
